import Navbar from '../component/Navbar';
import Footer from '../component/Footer';
import AwardDistributionHero from '../component/AwardDistributionHero';

const galleryImages = [
  {
    src: 'gal1.jpeg',
    alt: 'AI Sanctuary award distribution group photo',
    featured: true,
  },
  {
    src: 'WhatsApp Image 2026-07-08 at 11.46.27 AM.jpeg',
    alt: 'Students and mentors at AI Sanctuary ceremony',
  },
  {
    src: 'gal2.jpeg',
    alt: 'Speaker addressing the AI Sanctuary event',
  },
  {
    src: 'WhatsApp Image 2026-07-08 at 11.48.05 AM.jpeg',
    alt: 'AI Sanctuary participants group portrait',
  },
  {
    src: 'WhatsApp Image 2026-07-08 at 11.51.15 AM.jpeg',
    alt: 'Certificate presented during award distribution',
  },
  {
    src: 'gal3.jpeg',
    alt: 'AI Sanctuary award ceremony participant group',
  },
  {
    src: 'gal4.jpeg',
    alt: 'Student receiving certificate at AI Sanctuary',
  },
  {
    src: 'gal5.jpeg',
    alt: 'AI Sanctuary students group photo',
  },
  {
    src: 'WhatsApp Image 2026-07-08 at 12.25.08 PM.jpeg',
    alt: 'AI Sanctuary award distribution event moment',
  },
];

const highlights = [
  {
    title: 'Recognizing Achievement',
    description: 'Certificates and awards were presented to students who showed dedication, skill, and strong progress.',
  },
  {
    title: 'Mentor Appreciation',
    description: 'The ceremony brought instructors, mentors, and learners together to celebrate shared effort.',
  },
  {
    title: 'Community Moment',
    description: 'Group photos, speeches, and stage moments captured the energy of the AI Sanctuary learning community.',
  },
];

const ceremonyOverview = [
  {
    icon: '01',
    title: 'Certificate Presentations',
    description: 'Learners were recognized on stage for their effort, discipline, and visible progress.',
  },
  {
    icon: '02',
    title: 'Community Recognition',
    description: 'Students, mentors, and guests shared a formal moment of appreciation and encouragement.',
  },
  {
    icon: '03',
    title: 'Memorable Group Moments',
    description: 'The event closed with portraits and ceremony photos that captured the full learning community.',
  },
];

function PhotoTile({ image, className = '', imgClassName = '' }) {
  const src = `${process.env.PUBLIC_URL}/images/${image.src}`;

  return (
    <div className={`relative overflow-hidden rounded-xl bg-[#162D66] ${className}`}>
      <div
        className="absolute inset-0 scale-110 bg-cover bg-center blur-xl"
        style={{ backgroundImage: `url("${src}")` }}
      />
      <div className="absolute inset-0 bg-[#081430]/38" />
      <img
        src={src}
        alt={image.alt}
        className={`relative z-10 h-full w-full object-contain ${imgClassName}`}
        loading="lazy"
      />
    </div>
  );
}

export default function AwardDistribution() {
  const heroImage = {
    src: 'faizann.jpeg',
    alt: 'AI Sanctuary award ceremony participant group',
  };

  return (
    <div className="bg-white">
      <Navbar />

      <main>
        <AwardDistributionHero />

        <section className="relative overflow-hidden px-4 py-10 sm:px-8 sm:py-14 lg:px-[80px] lg:py-16">
          <div
            className="absolute inset-0"
            style={{
              background: 'linear-gradient(135deg, #E8EEFF 0%, #F5F8FF 52%, #FFFFFF 100%)',
            }}
          />
          <div className="absolute inset-0 pointer-events-none overflow-hidden">
            <img
              src={`${process.env.PUBLIC_URL}/images/bgline.svg`}
              alt=""
              className="absolute left-[8%] top-[-18%] h-[135%] w-[115%] object-contain opacity-80"
            />
          </div>

          <div className="relative z-10 mx-auto grid max-w-[1080px] grid-cols-1 gap-8 lg:min-h-[500px] lg:grid-cols-[0.86fr_1.14fr] lg:items-center">
            <div className="max-w-[620px]">
              <p
                className="mb-3 text-[13px] font-bold uppercase text-[#0F7FDE]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.08em' }}
              >
                New Event
              </p>
              <h1
                className="text-[36px] font-bold leading-[1.08] text-[#162D66] sm:text-[48px] lg:text-[64px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                Award Distribution Ceremony
              </h1>
              <p
                className="mt-5 max-w-[560px] text-[17px] leading-[28px] text-[#5A666E] sm:text-[20px] sm:leading-[32px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                A premium celebration of student achievements, mentor support, and the AI Sanctuary community.
              </p>
            </div>

            <div className="flex justify-center lg:justify-end">
              <img
                src={`${process.env.PUBLIC_URL}/images/${heroImage.src}`}
                alt={heroImage.alt}
                className="max-h-[640px] w-auto max-w-full rounded-xl object-contain shadow-[0_24px_70px_rgba(22,45,102,0.18)]"
              />
            </div>
          </div>
        </section>

        <section className="px-4 py-10 sm:px-8 sm:py-12 lg:px-[80px]">
          <div className="mx-auto grid max-w-[1080px] grid-cols-1 overflow-hidden rounded-xl border border-[#DCE7F7] bg-[#F8FAFC] lg:grid-cols-[0.9fr_1.1fr]">
            <div className="bg-[#F5F8FF] p-6 sm:p-8 lg:p-10">
              <p
                className="text-[13px] font-bold uppercase text-[#0F7FDE]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.08em' }}
              >
                Ceremony Overview
              </p>
              <h2
                className="mt-3 text-[28px] font-semibold leading-[1.15] text-[#162D66] sm:text-[36px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                A formal celebration for our achievers
              </h2>
              <p
                className="mt-4 text-[16px] leading-[26px] text-[#5A666E] sm:text-[17px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                The ceremony was planned to honor student effort with stage recognition, certificates, and
                professional event memories.
              </p>
            </div>

            <div className="divide-y divide-[#DCE7F7] bg-white">
              {ceremonyOverview.map((item) => (
                <div key={item.title} className="grid grid-cols-[58px_1fr] gap-4 p-5 sm:grid-cols-[72px_1fr] sm:p-6">
                  <div
                    className="flex h-12 w-12 items-center justify-center rounded-full bg-[#EEF5FF] text-[15px] font-bold text-[#162D66] sm:h-14 sm:w-14"
                    style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
                  >
                    {item.icon}
                  </div>
                  <div>
                    <h3
                      className="text-[18px] font-semibold text-[#162D66] sm:text-[20px]"
                      style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
                    >
                      {item.title}
                    </h3>
                    <p
                      className="mt-2 text-[15px] leading-[24px] text-[#5A666E]"
                      style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 pb-12 sm:px-8 lg:px-[80px] lg:pb-16">
          <div className="mx-auto grid max-w-[1080px] grid-cols-1 gap-8 lg:grid-cols-[0.95fr_1.05fr] lg:items-center">
            <PhotoTile
              image={{
                src: 'WhatsApp Image 2026-07-08 at 11.51.15 AM.jpeg',
                alt: 'Certificate presentation at AI Sanctuary award distribution',
              }}
              className="h-[520px] sm:h-[600px] lg:h-[560px]"
            />

            <div>
              <p
                className="mb-3 text-[13px] font-bold uppercase text-[#0F7FDE]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.08em' }}
              >
                Event Recap
              </p>
              <h2
                className="text-[30px] font-semibold leading-[1.15] text-[#162D66] sm:text-[40px] lg:text-[46px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                Celebrating hard work with a memorable stage moment
              </h2>
              <p
                className="mt-5 text-[17px] leading-[28px] text-[#5A666E] sm:text-[18px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                The Award Distribution Ceremony highlighted the progress of AI Sanctuary learners through
                certificates, appreciation moments, speeches, and community photos. It was designed to feel formal,
                warm, and memorable for every participant.
              </p>
            </div>
          </div>
        </section>

        <section className="bg-[#F8FAFC] px-4 py-12 sm:px-8 lg:px-[80px] lg:py-16">
          <div className="mx-auto max-w-[1080px]">
            <div className="mb-8 max-w-[720px]">
              <p
                className="mb-3 text-[13px] font-bold uppercase text-[#0F7FDE]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.08em' }}
              >
                Highlights
              </p>
              <h2
                className="text-[30px] font-semibold leading-[1.15] text-[#162D66] sm:text-[40px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                Moments from the ceremony
              </h2>
            </div>

            <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
              {highlights.map((item) => (
                <div key={item.title} className="rounded-xl border border-[#DCE7F7] bg-white p-6 shadow-sm">
                  <h3
                    className="text-[20px] font-semibold text-[#162D66]"
                    style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
                  >
                    {item.title}
                  </h3>
                  <p
                    className="mt-3 text-[15px] leading-[24px] text-[#5A666E]"
                    style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
                  >
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 py-12 sm:px-8 lg:px-[80px] lg:py-16">
          <div className="mx-auto max-w-[1080px]">
            <div className="mb-8 flex flex-col gap-3 sm:mb-10">
              <p
                className="text-[13px] font-bold uppercase text-[#0F7FDE]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.08em' }}
              >
                Gallery
              </p>
              <h2
                className="text-[30px] font-semibold leading-[1.15] text-[#162D66] sm:text-[40px]"
                style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '0.005em' }}
              >
                Award Distribution in pictures
              </h2>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {galleryImages.map((image) => (
                <PhotoTile
                  key={image.src}
                  image={image}
                  className="h-[280px] sm:h-[300px] lg:h-[320px]"
                />
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
